import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class SimpleAccordionItem extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get text() {
    return get(this, '_text.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/SimpleAccordionItem.model.js